import { render } from "./vcoupon.vue?vue&type=template&id=6a5d036c&scoped=true"
import script from "./vcoupon.vue?vue&type=script&lang=js"
export * from "./vcoupon.vue?vue&type=script&lang=js"

import "./vcoupon.vue?vue&type=style&index=0&id=6a5d036c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5d036c"]])

export default __exports__